
import { Component, Vue, Prop } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { listMixin } from "@/mixins/listMixin";
import MainHeader from "../../../main/components/main-header/main-header.vue";
import NavLeft from "../../../main/components/nav-left/nav-left.vue";
import Pagination from "@/components/paginaiton.vue";
import { GetKepuList, DelKepu, EditKepu } from "@/request/content";
@Component({
  components: {
    MainHeader,
    NavLeft,
    Pagination,
  },
})
export default class Name extends mixins(listMixin) {
  private window: any = window;
  private ifShowSource: any = false;
  private source: any = "";
  private data: any[] = [];
  private types: any = [
    "运动康复",
    "睡眠",
    "心理",
    "营养",
    "动脉斑块",
    "冠心病",
    "血管抗衰老",
  ];
  private H: any = "";
  private forceUpdate() {
    this.$forceUpdate();
  }
  private changeStatus(item: any, val: any) {
    const params: any = {
      kepu_id: item.kepu_id,
      标题: item["标题"],
      作者: item["作者"],
      正文: item["正文"],
      封面: item["封面"],
      类别: item["类别"],
      状态: val,
      附加参数:item['附加参数'],
      内容来源: item['内容来源'],
    };
    EditKepu(this, params).then((res: any) => {
      this.$message.success(val == "未发布" ? "撤回" : "发布" + "成功！");
      this.getList();
    });
  }
  private goAdd() {
    this.source = "";
    this.ifShowSource = true;
  }
  private goAddPage() {
    if (!this.source) {
      this.$message.warning("请选择内容来源！");
      return;
    }
    this.ifShowSource = false;
    this.$router.push({
      path: "/main/content/kepuku-compose-kepu",
      query: {
        type: this.source,
      },
    });
  }
  private goEdit(item: any) {
    this.$router.push({
      path: "/main/content/kepuku-compose-kepu",
      query: {
        id: item.kepu_id,
        type: item["内容来源"],
      },
    });
  }
  /**
   * @description 删除
   */
  private deleteOne(item: any, index: any) {
    this.$confirm("确定删除该条记录么？", "删除", {
      customClass: "commonConfirm",
    }).then(() => {
      const params: any = {
        data: {
          kepu_id: item.kepu_id,
        },
      };
      DelKepu(this, params).then((res: any) => {
        this.$message.success("删除成功");
        if (this.data.length === 1 && this.filters.current_page !== 1) {
          this.filters.current_page--;
        }
        this.search();
      });
    });
  }
  /**
   * @description 获取列表
   */
  getList() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params = {
      类别: this.filters["类别"],
      状态: this.filters["状态"],
      search: this.filters.search,
      //   sort_value: this.filters.sort_value,
      current_page: this.filters.current_page,
      page_count: this.filters.page_count,
    };
    localStorage.setItem("kepukuFilter", JSON.stringify(this.filters));
    GetKepuList(this, params)
      .then((res: any) => {
        loading.close();
        this.data = res.kepus;
        this.filters.total_count = res.total_count;
        this.filters.total_page = res.total_page;
        if (this.data.length > 0) {
          this.ifShowEmpty = false;
        } else {
          this.ifShowEmpty = true;
        }
      })
      .catch(() => {
        loading.close();
      });
  }
  mounted() {
    this.filters.sort_field = "更新时间";
    this.filters.sort_value = 1;
    this.H = document.body.clientHeight - 100;
    if (localStorage.getItem("kepukuFilter")) {
      this.filters = JSON.parse(localStorage.getItem("kepukuFilter") as any);
    }
    this.getList();
  }
}
